import { Modal, TitleBar } from "@shopify/app-bridge-react"
import { ModalProps } from "@shopify/polaris"

export interface ShopifyModalProps
  extends Pick<
    ModalProps,
    | "open"
    | "onClose"
    | "title"
    | "children"
    | "primaryAction"
    | "secondaryActions"
    | "sectioned"
    | "size"
  > {}
export const ShopifyModal = (props: ShopifyModalProps) => {
  const {
    open,
    onClose,
    title,
    sectioned,
    children,
    size = "base",
    primaryAction,
    secondaryActions,
  } = props

  if (!open) return null
  return (
    <Modal
      open={open}
      variant={size === "fullScreen" ? "max" : size}
      onHide={function () {
        onClose?.()
      }}
    >
      <TitleBar title={title as string}>
        {primaryAction && (
          <button
            variant={primaryAction.variant ?? "primary"}
            tone={(primaryAction as any).tone}
            loading={primaryAction.loading ? "" : undefined}
            disabled={primaryAction.disabled}
            onClick={primaryAction.onAction}
          >
            {primaryAction.content}
          </button>
        )}
        {secondaryActions?.map((item, _i) => {
          const i = _i + 1
          return (
            <button
              key={i}
              loading={item.loading ? "" : undefined}
              disabled={item.disabled}
              onClick={item.onAction}
            >
              {item.content}
            </button>
          )
        })}
      </TitleBar>
      {sectioned !== false ? (
        <div className="w-full p-4">{children}</div>
      ) : (
        children
      )}
    </Modal>
  )
}
